import useQueryParam from 'hooks/shared/useQueryParam';

const useAccountIdQueryParam = (): [ID | undefined, (accountId: ID | undefined) => void] => {
  const [accountId, setAccountId] = useQueryParam<ID | undefined>('account_id', {
    ifAbsent: undefined,
    provider: (val) => val ? +val : undefined,
  });

  return [accountId, setAccountId];
};

export default useAccountIdQueryParam;
